import getScript from './utils/getScript';
import waitFor from './utils/waitFor';

export const jwBaseUrl = 'https://cdn.jwplayer.com/';

export function waitForJwPlayer(frequency = 200, timeout = 6000) {
  return new Promise((resolve, reject) => {
    let timeoutId = null;
    const id = setInterval(() => {
      if (window.jwplayer) {
        clearInterval(id);
        clearInterval(timeoutId);
        resolve();
      }
    }, frequency);

    timeoutId = setTimeout(() => {
      clearInterval(id);
      reject(new Error('No window.jwplayer found. Timed out'));
    }, timeout);
  });
}

/**
 * Waits for selected el to exist before resolving
 *
 * @param {string} selector - Element to find.
 * @param {Document | Element} context - Context to look in for selector.
 * @returns {Promise}
 */
export function waitForSelector(selector = '.jwplayer', context = window.document) {
  return waitFor(() => context.querySelector(selector));
}

/**
 * Adds jwplayer script
 *
 * @param {string} playerID
 * @returns {Promise}
 */
export async function addPlayerLibraryIfNotExists(playerID) {
  const src = `${jwBaseUrl}/libraries/${playerID}.js`;
  return await getScript(document, src).catch((err) => console.log(err));
}
